const OPERATIONS_MY_FEATURES_PATH = '/api/v1/operations/my-features';

function getCurrentClientHint(): string | null {
  if (typeof window === 'undefined') {
    return null;
  }

  const rawClientId = window.localStorage.getItem('current_client_id');
  if (typeof rawClientId !== 'string') {
    return null;
  }

  const normalizedClientId = rawClientId.trim();
  return normalizedClientId.length > 0 ? normalizedClientId : null;
}

export function getOperationsMyFeaturesPath(options: { cacheBust?: boolean } = {}): string {
  const params = new URLSearchParams();
  const currentClientHint = getCurrentClientHint();

  if (currentClientHint) {
    params.set('client_hint', currentClientHint);
  }

  if (options.cacheBust !== false) {
    params.set('_ts', String(Date.now()));
  }

  const query = params.toString();
  return query ? `${OPERATIONS_MY_FEATURES_PATH}?${query}` : OPERATIONS_MY_FEATURES_PATH;
}

export function getOperationsMyFeaturesFetchInit(
  accessToken?: string | null,
  init: RequestInit = {},
): RequestInit {
  const headers = new Headers(init.headers || undefined);

  if (accessToken && !headers.has('Authorization')) {
    headers.set('Authorization', `Bearer ${accessToken}`);
  }

  return {
    ...init,
    cache: 'no-store',
    credentials: init.credentials || 'include',
    headers,
  };
}